window.services = {
	init: function () {
		getEl('.vg-services-show .scroll-line').forEach((container) => {
			const s = new this.lineAction(container);
			this.scrollEventListener(function () {
				s.scrollLine();
			});
		});

		getEl('.vg-services-show .info-list').forEach((container) => {
			let lastScroll = 0,
				offset = 200;

			const s = new this.infoListAction(container);
			this.scrollEventListener(function () {

				if (lastScroll > window.pageYOffset) {
					offset = 400
				}

				s.infoListActive(offset);
				lastScroll = window.pageYOffset;
			});

			scrollToSection(
				'.vg-services-show .title-area-sticky .sticky-title',
				offset
			)
		});
	},

	scrollEventListener: (callback) => {
		let tmScrollLine;
		window.addEventListener('scroll', () => {
			clearInterval(tmScrollLine);
			tmScrollLine = setTimeout(function () {
				callback();
			}, 50);
		});
	}
};

window.services.lineAction = function (container) {
	this.items = getEl('.scroll-line-item', container);
	this.lineArea = getEl('.lines-area', container);
	this.line = getEl('.line', this.lineArea[0]);
	this.list = () => {
		let list = {};

		this.items.forEach((el) => {
			let id = el.getAttribute('data-id');
			list[id] = {
				height: el.offsetTop,
				visible: false
			};
		});

		return list;
	};

	this.lineArea[0].style.height = `calc(100% - ${this.items[this.items.length - 1].clientHeight - 24}px)`;

	this.scrollLine = function () {
		let lineHeight = this.line[0].clientHeight;
		const list = this.list();

		const getHeight = () => {
			let result = null;
			this.items.forEach((el) => {
				let visible = visibleSection(el, 'center');
				let id = el.getAttribute('data-id');
				list[id].visible = visible;

				if (visible) {
					el.classList.add('active');
					result = list[id];
				} else {
					el.classList.remove('active');
				}
			});

			return result;
		};

		const scroller = () => {
			let option = getHeight();
			if (!option) {
				this.line[0].style.height = 0;
				return
			}
			if (option.visible) {
				lineHeight = option.height;
				this.line[0].style.height = lineHeight + 'px';
			}
		};

		return scroller();
	};

	return this;
};

window.services.infoListAction = function (container) {
	this.infoListActive = function (offset) {

		const item = getEl('.info-list-item', container),
			visibleContainer = visibleSection(container, 'center'),
			subtitles = getEl('.info-list-wrapper .wrapper-item', container),
			stickyTitle = getEl('.title-area-sticky .sticky-title', container);

		subtitles.forEach((subtitle, index, arr) => {
			let length = arr.length - 1;
			let nextElement = length >= [index + 1] ? arr[index + 1] : arr[length];
			const visibleElem = visibleSection(subtitle, 'bottom', offset);
			const visibleNextElem = visibleSection(nextElement, 'bottom', offset);

			if (visibleElem) {
				stickyTitle[index].classList.add('active');
			} else {
				stickyTitle[index].classList.remove('active');
			}

			if (visibleNextElem) {
				let i = index + 1;
				stickyTitle[i - 1].classList.remove('active');

				if(stickyTitle[length]) {
					stickyTitle[length].classList.add('active');
				}
			}
		});

		if (visibleContainer) {
			item.forEach((e, index) => {
				setTimeout(() => {
					e.classList.add('active');
				}, index * 250);
			})
		}
	};
};

services.init();